import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { d as s, ag as P, ah as S, x as A } from "../../../vendor-EQDp64ng.js";
import { useId as B } from "react";
import { getSpacingClasses as E } from "../../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as W } from "../../../utils/omitStyleRenderProps/index.js";
import { s as r } from "../../../shared.module-BNaUp3Ey.js";
import { useDrawerResize as k } from "./useDrawerResize.js";
import '../../../assets/index19.css';const F = "_drawer_1fja8_1", H = "_dialog_1fja8_46", K = "_resizer_1fja8_61", L = "_resizerIndicator_1fja8_97", a = {
  drawer: F,
  dialog: H,
  resizer: K,
  resizerIndicator: L
}, U = 300, Z = ({
  children: m,
  placement: o = "right",
  backdrop: f = !0,
  offsetBottom: p = 0,
  offsetTop: b = 0,
  width: _,
  defaultWidth: g,
  minWidth: h = U,
  maxWidth: u,
  allowsResizing: w = !1,
  onResize: x,
  onResizeEnd: z,
  p: D,
  pb: $,
  pl: I,
  pr: j,
  pt: y,
  ...t
}) => {
  const N = s(r.overlay, f && r.backdrop), R = s(a.drawer, r.surface, E({ p: D, pb: $, pl: I, pr: j, pt: y })), i = Math.max(b, 0), d = Math.max(p, 0), O = `calc(100% - ${d + i}px)`, c = B(), { widthValue: T, setDrawerRef: v, resizerProps: C, inputProps: M } = k({
    width: _,
    defaultWidth: g,
    minWidth: h,
    maxWidth: u,
    placement: o,
    onResize: x,
    onResizeEnd: z,
    dialogId: c
  }), l = {
    height: O,
    marginBottom: d,
    marginTop: i
  };
  return l["--drawer-width"] = T, /* @__PURE__ */ e(
    P,
    {
      ...W(t),
      isDismissable: !0,
      isKeyboardDismissDisabled: !1,
      shouldCloseOnInteractOutside: () => !0,
      className: N,
      children: /* @__PURE__ */ n(
        S,
        {
          ref: v,
          "data-component": "Drawer",
          "data-placement": o,
          className: R,
          style: l,
          children: [
            /* @__PURE__ */ e(
              A,
              {
                id: c,
                role: "dialog",
                className: s(r.dialog, a.dialog),
                "aria-label": t["aria-label"],
                children: m
              }
            ),
            w && // Two-element resize pattern (following react-aria's ColumnResizer):
            // - Outer <div> handles pointer (mouse/touch/pen) drag via useMove
            // - Inner visually-hidden <input type="range"> handles keyboard and
            //   screen reader interactions with native semantics.
            /* @__PURE__ */ n("div", { className: a.resizer, ...C, children: [
              /* @__PURE__ */ e("span", { className: a.resizerIndicator, "aria-hidden": "true" }),
              /* @__PURE__ */ e("input", { ...M })
            ] })
          ]
        }
      )
    }
  );
};
export {
  Z as Drawer
};
